import { getFilipinoAddressSchema } from '@breezeventures/web-ph-validators/zod-schemas';
import { requiredNullish } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

export const businessAddressSchema = z.object({
  country: z.string(),
  region: z.string(),
  province: requiredNullish(z.string().trim().min(1, 'Province is required')),
  cityOrMunicipality: requiredNullish(
    z.string().trim().min(1, 'City/Municipality is required')
  ),
  barangay: requiredNullish(z.string().trim().min(1, 'Barangay is required')),
  postalCode: z
    .string()
    .trim()
    .min(1, 'ZIP Code is required')
    .regex(/^\d+$/, 'ZIP Code must contain only numbers'),
  streetAndHouse: getFilipinoAddressSchema({
    required: true,
    requiredMessage: 'House number and street name is required',
    message: "Use only letters and symbols ' . - ( ) /",
  }),
  unitAndFloor: getFilipinoAddressSchema({
    message: "Use only letters and symbols ' . - ( ) /",
  }).nullish(),
});

export type BusinessAddressFormValues = z.infer<typeof businessAddressSchema>;
